export default __webpack_public_path__ + "land-use-800-16edc236270b7305dfe1b25e7cfddf6e.png";